import styles from './Sidebar.style';

const Sidebar = ({ classes, children, className }) => (
  <div className={classnames(classes.root, className)}>{children}</div>
);

const SidebarTitleRow = ({ classes, children, className }) => (
  <div className={classnames(classes.titleRow, className)}>{children}</div>
);

const SidebarTitle = ({ classes, children, className }) => (
  <h2 className={classnames(classes.title, className)}>{children}</h2>
);

const SidebarFooter = ({ classes, children, className }) => (
  <div className={classnames(classes.stickyFooter, className)}>{children}</div>
);

const SidebarSubtitle = ({ classes, children }) => (
  <h3 className={classes.subtitle}>{children}</h3>
);

const SidebarDivider = ({ classes, className }) => (
  <hr className={classnames(classes.divider, className)} />
);

const SidebarContent = ({
  classes,
  children,
  className,
  noPadding,
  ...rest
}) => (
  <div className={classnames(classes.content, className)} {...rest}>
    <div
      className={classnames(classes.contentContainer, {
        [classes.noPadding]: noPadding,
      })}>
      {children}
    </div>
  </div>
);

const StyledSidebarTitle = withStyles(styles)(SidebarTitle);

const StyledSidebarTitleRow = withStyles(styles, {
  name: 'AppSidebarTitleRow',
})(SidebarTitleRow);

const StyledSidebarFooter = withStyles(styles, {
  name: 'AppSidebarFooter',
})(SidebarFooter);

const StyledSidebarSubtitle = withStyles(styles, {
  name: 'AppSidebarSubtitle',
})(SidebarSubtitle);

const StyledSidebarDivider = withStyles(styles)(SidebarDivider);

const StyledSidebarContent = withStyles(styles)(SidebarContent);

Sidebar.propTypes = {
  maxWidth: PropTypes.string,
};

Sidebar.defaultProps = {
  maxWidth: '500px',
};

export default withStyles(styles)(Sidebar);

export {
  StyledSidebarTitle as SidebarTitle,
  StyledSidebarSubtitle as SidebarSubtitle,
  StyledSidebarFooter as SidebarFooter,
  StyledSidebarContent as SidebarContent,
  StyledSidebarDivider as SidebarDivider,
  StyledSidebarTitleRow as SidebarTitleRow,
};
